/**
 * Created by Josef Jurca on 3.10.2017.
 */
import _ from 'lodash';

import {getInstance as getDataSources} from 'datasources';
import {
    ActiveViewStatuses,
    setActiveViewStatus
} from 'store/actions/viewtree';

const ActionTypes = {
        SET_PAYMENT_HISTORY_STATE: 'SET_PAYMENT_HISTORY_STATE',
        SET_PAYMENT_HISTORY_DATA: 'SET_PAYMENT_HISTORY_DATA'
    },

    PaymentHistoryStates = {
        INITIAL: 'INITIAL',
        LOADING: 'LOADING',
        REQUEST_FAILURE: 'REQUEST_FAILURE',
        REQUEST_SUCCESS: 'REQUEST_SUCCESS'
    };

/**
 * Sets the history state.
 *
 * @param {string} state - Payment history state.
 * @returns {Object} Action object.
 */
function setPaymentHistoryState  (state) {

    return {
        type: ActionTypes.SET_PAYMENT_HISTORY_STATE,
        state: state
    };
}

/**
 * Sets the history data.
 *
 * @param {string} state - Payment history state.
 * @returns {Object} Action object.
 */
function setPaymentHistoryData  (state) {

    return {
        type: ActionTypes.SET_PAYMENT_HISTORY_DATA,
        state: state
    };
}

/**
 * Get payment history.
 *
 * @param {string} userId - User ID.
 * @returns {Object} Action type and error object.
 */
function getPaymentHistory (userId) {

    return (dispatch) => {

        dispatch(setPaymentHistoryState(PaymentHistoryStates.LOADING));

        let dataSources = getDataSources();

        // get default payment gateway
        return dataSources.listPaymentGateways()
            .then((gateways) => {
                let defaultPaymentGateway = null;

                _.each(gateways, (gateway) => {
                    if (gateway.isDefaultGateway()) {
                        defaultPaymentGateway = gateway;
                    }
                });

                // in case none is default, pick first one
                if (!defaultPaymentGateway && gateways.length) {
                    defaultPaymentGateway = gateways[0];
                }

                return defaultPaymentGateway;

            })
            .then((defaultGateway) => {

                let getPaymentHistoryParams = {
                    defaultGateway: defaultGateway.id,
                    userId: userId
                };

                return dataSources.getPaymentHistory(getPaymentHistoryParams)
                    .then((paymentHistory) => {

                        dispatch(setPaymentHistoryState(PaymentHistoryStates.REQUEST_SUCCESS));
                        dispatch(setPaymentHistoryData(paymentHistory));
                        dispatch(setActiveViewStatus(ActiveViewStatuses.READY));

                    });
            })
            .catch((response) => {
                let error = _.get(response, ['result', 'error']);

                dispatch(setPaymentHistoryState(PaymentHistoryStates.REQUEST_FAILURE));

                if (error && (typeof error === 'string' || error.message)) {

                    error = typeof error === 'string'
                        ? error
                        : error.message;
                } else {

                    error = 'Unknown Error';
                }
                return Promise.reject(error);
            });
    };
}


export {
    ActionTypes,
    PaymentHistoryStates,
    getPaymentHistory
};


// WEBPACK FOOTER //
// ./src/js/store/actions/pages/paymenthistory.js